import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const MobileAppLinkingConfigDetailScene = lazy(() =>
  import("@scenes/UniversalLinks/components/MobileAppLinkingConfigDetail").then((module) => ({
    default: module.MobileAppLinkingConfigDetailScene,
  }))
);

export const mobileAppLinkingConfigDetailNRO: NavigationRoutingObject = {
  section: "settings",
  Component: MobileAppLinkingConfigDetailScene,
  heading: (t: I18nT<"dashboard-navigation">) => t("universal-links-nro-heading", "Universal Links"),
  pageNameForTracking: () => "Universal Links Config",
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  getDeveloperNavigationAllowed: ({ hasPermission, featureOn }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return (
      hasPermission("company", { permission: "viewDomainSettings" }) ||
      hasPermission("company", { permission: "editDomainSettings" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/company_settings/universal_links/:appGroupId",
};
